export const MAX_REVIEW_LENGTH = 150;

export const getText = (text: string, isFullView: boolean) => {
  if (!isFullView && text.length > MAX_REVIEW_LENGTH) {
    return `${text.substr(0, MAX_REVIEW_LENGTH).trim()}\u2026`;
  }

  return text;
};
